export default "__VITE_ASSET__144f32d1__"